import {
  ProductType,
  FuelType,
  AgreementType,
  IMeterPointAgreement,
  IMeterPointAgreementProductDetails,
} from "./meterpointAgreement.types"
import { Status } from "@/types/Status"
import dayjs, { Dayjs } from "dayjs"

export class MeterPointAgreement implements IMeterPointAgreement {
  constructor(
    public fromDate: Dayjs,
    public isCancelled: boolean,
    public juniferAgreementNumber: string,
    public orderedDate: Dayjs,
    public type: AgreementType,
    public productDetails: IMeterPointAgreementProductDetails,
    public toDate?: Dayjs,
  ) {
    this.toDate = this.toDate?.subtract(1, "day").endOf("day")
  }

  get isActive() {
    const today = dayjs()
    return (
      !this.isCancelled &&
      this.fromDate?.isBefore(today) &&
      (!this.toDate || this.toDate.isAfter(today))
    )
  }

  get isPending() {
    const today = dayjs()
    return !this.isCancelled && this.fromDate.isAfter(today)
  }

  get status(): Status {
    if (this.isCancelled) return new Status("critical", "Cancelled")
    if (this.isPending) return new Status("caution", "Pending")
    if (this.isActive) return new Status("normal", "Active")
    return new Status("default", "Completed")
  }

  get isElecEvTariff(): boolean {
    return (
      this.productDetails.isEvTariff &&
      this.productDetails.fuelType === FuelType.ELECTRICITY
    )
  }

  get isEco7Product() {
    return this.productDetails.productType === ProductType.Eco7
  }

  get isStandardProduct() {
    return this.productDetails.productType === ProductType.Standard
  }

  get isSoUniqueTariff() {
    return (
      this.productDetails.productType === ProductType.TOU &&
      this.productDetails.code.startsWith("E3R-TOU")
    )
  }

  get isTouTariff() {
    return this.productDetails.productType === ProductType.TOU
  }
}
